import { useState } from "react"

const useLogout = () => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  const [shouldRefresh, setShouldRefresh] = useState(false)

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true)
  }

  const handleConfirmLogout = () => {
    setShowLogoutConfirm(false)
    setShouldRefresh(true)
    localStorage.removeItem('blendOptimizerCurrentUser')
    window.location.reload()
  }

  const handleCancelLogout = () => {
    setShowLogoutConfirm(false)
  }

  return {
    showLogoutConfirm,
    shouldRefresh,
    handleLogoutClick,
    handleConfirmLogout,
    handleCancelLogout,
    setShouldRefresh
  }
}

export default useLogout